import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import '../styles/navbar.css';

export default function Navbar() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.loggedIn) {
                    setLoggedIn(true);
                    setUsername(data.username || "Felhasználó");
                    setIsAdmin(data.is_admin === 1);
                } else {
                    setLoggedIn(false);
                    setIsAdmin(false);
                }
            });
    }, []);

    const handleLogout = async () => {
        await fetch("https://focifanatik.hu/api/logout.php", {
            credentials: "include"
        });
        setLoggedIn(false);
        setIsAdmin(false);
    };


    return (
        <nav className="navbar navbar-expand-lg bg-body-tertiary fixed-navbar">
            <div className="container-fluid">

                {isAdmin && (
                    <Link className="nav-link admin-link" to={"/admin/kezdolap"}>
                        Admin
                    </Link>
                )}
                {/* KÖZÉPRE ZÁRT CSOPORT */}
                <div className="navbar-center-group">

                    {/* Brand */}
                    <Link className="navbar-brand fw-bold text-white" to={"/kezdolap"}>
                        <img className="navbar-logo" src="/images/logo.png" alt="FociFanatik" />
                    </Link>


                    {/* Mobil toggler (csak mobilon látszik) */}
                    <button
                        className="navbar-toggler ms-auto d-lg-none"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Menü */}
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <Link className="nav-link" to={"/szavazas"}>Szavazás</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to={"/meccselemzo"}>Statisztikák</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to={"/strategiak"}>Stratégiák</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to={"/jegyzetek"}>Jegyzetek</Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className="nav-link" to={"/kalkulator-odds"}>Kalkulátorok</Link>
                            </li> */}
                            {/* <li className="nav-item">
                                <Link className="nav-link" to={"/gyik"}>GYIK</Link>
                            </li> */}
                        </ul>
                    </div>

                    {/* Auth gomb / dropdown */}
                    <div className="navbar-auth">
                        {!loggedIn ? (
                            <Link to="/bejelentkezes" className="auth-minimal-btn">
                                Belépés / Regisztráció
                            </Link>
                        ) : (
                            <div className="dropdown">
                                <button
                                    className="auth-minimal-btn"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {username}
                                </button>

                                <ul className="dropdown-menu dropdown-menu-end shadow">
                                    <li>
                                        <Link className="dropdown-item" to={`/profilom/${username}`}>Profilom</Link>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <button className="dropdown-item text-danger" onClick={handleLogout}>
                                            Kijelentkezés
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>


                </div>
            </div>
        </nav>
    );
}
